import React from 'react';

import Modal from '../../../layouts/Modal';
import styles from './styles.module.scss';
import Button from '../../Button';

interface Props {
  isOpen: boolean;
  setIsOpen: (is: boolean) => void;
  callback?: () => void;
}

export default function BookMarkModal({isOpen, setIsOpen, callback}: Props) {
  return (
    <Modal.Alert
      width={'315px'}
      height={'246px'}
      isOpen={isOpen}
      style={{borderRadius: '10px'}}>
      <div className={styles.contents} style={{padding: '30px 16px 10px 16px'}}>
        <div className={styles.iconArea}>
          <span className={styles.bookmarkIcon}></span>
        </div>
        <div className={styles.txtArea}>
          브랜드를 스크랩하고
          <br />
          스페셜 할인 혜택을 누리세요
        </div>
        <div className={styles.buttonArea}>
          <Button.ModalButton
            width={'100%'}
            height={'50px'}
            txt={'스크랩하고 혜택권 받기'}
            background={'#000'}
            color={'#fff'}
            onClick={() => (callback ? callback() : '')}
          />
          <Button.ModalButton
            width={'100%'}
            height={'50px'}
            txt={'다음에 받기'}
            background={'#fff'}
            color={'#9F9CA3'}
            onClick={() => setIsOpen(false)}
          />
        </div>
      </div>
    </Modal.Alert>
  );
}
